<template>
    <div class="page no-top-bar">
        <TopBarDetail
            title="เหรียญตราของฉัน"
            isShowBack
            @clickBack="clickBack()"
        ></TopBarDetail>
        <div class="grid grid-cols-2 gap-2 px-5">
            <BadgeItem v-for="(badge,index) in badgesList"
                :key="index"
                :badge="badge"
                :modalController="modalController"
            ></BadgeItem>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//component
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
import BadgeItem from "../component/BadgeItem.vue";
//service
import BzbsBadge from "@/core/Badge/service/BzbsBadge.js";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";
export default {
    name: "Badge",
    mixins: [ModalMixin],
    components: {
        TopBarDetail,
        BadgeItem,
    },
    data: function() {
        return {
            isLoaded: false,
            progress: 50,
            badgesList: [],
        }
    },
    created: function() {
        this.tracking.screenName('badge');
        this.tracking.event('badge', 'view_badge');

        this.getBadge();
    },
    methods: {
        //#region mixin function
        onSetupModalCompleted: function() {
            this.initialbadgeAlertModal();
        },
        //#endregion mixin function
        getBadge: function () {
            let group = "splus";
            BzbsBadge.getBadges(group).subscribe({
                next: (data) => {
                    console.log(data);
                    this.badgesList = data;
                    this.isLoaded = true;
                },
                error: (err) => {
                    console.log(err);
                },
            });
        },
        clickBack: function () {
            this.$router.back();
        }

    }
}
</script>
